import axios from 'axios';
import i18n from '@/i18n.js';
import store from '@/store/';
import router from '@/router/';
import { mostrarPrecio, mostrarIdioma, formatearDireccionGoogle, getCentroGeodesica, pointInPolygon, mostrarImpuestoTexto, mostrarImpuestoPorcentaje } from '@/utils/funciones_auxiliares.js';
import { restSinNegocio, restSinNegocioParams } from "@/utils/restaurantes.utils.js";
import { functions, db } from '@/firebase'

export default {
	getNavigatorLocation({ commit }) {
		return new Promise((resolve, reject) => {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					let coord = [position.coords.latitude, position.coords.longitude];
					resolve(coord)

				}, function (error) {
					resolve('error');
				});
			} else {
				resolve('error');
				reject('Geolocation error')
			}
		});
	},
	// reorderRestaurants({ state, rootState, commit, dispatch }, data) {
	// 	return new Promise((resolve, reject) => {
	// 		let _vue = this;
	// 		let dist = [];
	// 		let position = state.addressObject.coordenadas;
	// 		let restaurantes = rootState.restaurante.listadoRestaurantes;

	// 		if (data != undefined) {
	// 			restaurantes = data;
	// 		} else {
	// 			restaurantes = rootState.restaurante.listadoRestaurantes;
	// 		}

	// 		restaurantes.forEach(function (e, i) {
	// 			let payload = {
	// 				lat1: position[0],
	// 				lon1: position[1],
	// 				lat2: e.latitud,
	// 				lon2: e.longitud
	// 			}
	// 			dispatch('getDistanceLatLonInKm', payload).then((e) => {
	// 				restaurantes[i].distancia = e;
	// 			})
	// 		})

	// 		resolve(restaurantes)
	// 	});
	// },
	getDistanceLatLonInKm_old({ state, commit }, data) {
		return new Promise((resolve, reject) => {
			let p = Math.PI / 180;
			let cos = Math.cos;
			let restaLat = data.lat2 - data.lat1;
			let restaLong = data.lon2 - data.lon1;

			let a = 0.5 - cos((restaLat) * p) / 2 + cos(data.lat1 * p) * cos(data.lat2 * p) * (1 - cos((restaLong) * p)) / 2;
			let r = 12742 * Math.asin(Math.sqrt(a));

			resolve(r);
		});
	},
	geocodeAddressToCoordinates({ state, commit }, data) {
		return new Promise((resolve, reject) => {
			let _vue = this;
			let geocoder = new google.maps.Geocoder();
			geocoder.geocode({
				'address': data,
				'componentRestrictions': { country: 'ES' }
			}, function (results, status) {
				if (status == 'OK') {
					let coord = [results[0].geometry.location.lat(), results[0].geometry.location.lng()];

					resolve(coord);

				} else if (status === 'INVALID_REQUEST') {
					reject("error")

				} else {
					reject("unknown error")

				};
			});
		});
	},
	geocodeCoordinatesToAddress({ state, commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			let _vue = this;
			let geocoder = new google.maps.Geocoder();
			let coordinates = {
				lat: payload[0],
				lng: payload[1]
			};

			geocoder.geocode({
				'location': coordinates
			}, async function (results, status) {
				let res = { ok: 'error', direccion: '', coordenadas: '' }
				if (status === google.maps.GeocoderStatus.OK) {

					if (results[0]) {
						let formateada = formatearDireccionGoogle(results[0].address_components)
						formateada.coordenadas = [coordinates.lat, coordinates.lng]
						formateada.formated = results[0].formatted_address ? results[0].formatted_address : '';
						// commit('setAddressObject', results[0].address_components)

						if (formateada.cp != "") {
							let codigoProvincia = await store.dispatch('direcciones/codigo_postal_a_codigo_provincia', { codigo_pais: formateada.codigoPais, cp: formateada.cp })
							// commit('setCodigoProvincia', codigoProvincia)
							formateada.codigoProvincia = codigoProvincia;

						}

						res.ok = 'ok';
						res.direccion = formateada;

						resolve(res)

					} else {
						reject(res)

					};

				} else {
					reject(res)
				};
			});
		});
	},
	elegirRestaurante({ state, rootState, commit, dispatch, rootGetters }, data) {//se usa
		let modo = rootState.direcciones.modoEligiendo;
		const obj = rootState.restaurante.listadoRestaurantes.find(r => r.id == data)
		commit('setDatosCompararNuevo', {
			restaurante: data,
			restauranteObj: obj,
			negocio: state.negocioPedido,
			negocioObj: state.negocioObjPedido,
			forma_envio: modo
		});
		//Setear el pdido minimo y recargo

		if (state.carrito.numero_producto > 0 && (state.restaurantePedido != data || state.negocioPedido != obj.negocio /*|| state.activePedido.forma_envio != modo*/)) {
			commit('pedido/setContinuarPedido', true, { root: true });
		} else {
			commit('setModo', modo);
			commit('setRestaurantePedido', data);
			commit('setRestauranteObjPedido', obj);
			if (obj.zonasReparto && obj.zonasReparto[0] && modo == 'domicilio') {
				commit('setPedidoMinimo', obj.minimo);
				commit('setRecargoPedido', obj.recargo);
			}
			dispatch("navegarPagePedido");
		}
	},
	navegarPagePedido({ state, commit, rootState, getters }, activeCat = false) { //se usa
		const restObj = state.restauranteObjPedido;
		const rest = state.restaurantePedido;
		const negocio = rootState.propio.negocioPropio
		let isPropio = rootState.propio.negocioPropio != null;
		let urlRest = isPropio ?
			restSinNegocioParams(rest, negocio) :
			rootState.pedido.negocioPedido + '/' + rootState.pedido.restaurantePedido;
		if (activeCat) {
			rootState.app.router.push('/pedir/' + state.activePedido.forma_envio + '/' + urlRest + '/' + state.activeCat.id);
		} else {
			console.log("dentro")
			rootState.app.router.push('/pedir/' + state.activePedido.forma_envio + '/' + urlRest);
		}
	},
	navegarPagePedidoPendiente({ state, commit, rootState, getters }) { //se usa
		const rest = state.restaurantePedido;
		let isPropio = rootState.propio.negocioPropio != null;
		let urlRest = isPropio ?
			rest :
			rootState.pedido.negocioPedido + '/' + restSinNegocioParams(rootState.pedido.restaurantePedido, rootState.pedido.negocioPedido);
		rootState.app.router.push('/pedir/' + state.activePedido.forma_envio + '/' + urlRest);

	},
	resetPedido({ state, commit, rootState }) {
		commit('resetCarrito');
		commit('resetActiveProduct');
		commit('resetActivePedido');
		commit('actualizarNota', "");

		if (rootState.propio.negocioPropio == null) { //si es propio no se vacían los restaurantes
			commit('restaurante/resetListadoRestaurante', null, { root: true });
			commit('resetActivePedidoNegocio');
		}

		commit('setPedidoMinimo', null);
		commit('setRecargoPedido', null);
		commit('restaurante/resetRestaurante', null, { root: true });
		//commit('restaurante/resetRestauranteActivo', null, { root: true });
		commit('restaurante/resetAllProducts', null, { root: true });
		commit('direcciones/resetDirecciones', null, { root: true });
		localStorage.removeItem('idPedidoAnonimo');
		//localStorage.removeItem('dirPidiendo')
		localStorage.removeItem('activeRestId')
	},
	getUltimosPedidos({ rootState, commit }) {
		return db.collection('pedidos')
			.where('uid', '==', rootState.auth.user.uid)
			.where('estado', '==', 'finalizado')
			.where('negocio', '==', rootState.propio.negocioPropio)
			.orderBy('fechaServidor', 'desc')
			.limit(1)
			.get().then((r) => {
				console.log(r);
				if (!r.empty) {
					var d = r.docs[0];
					commit('setUltimosPedidos', r.docs.map((dat) => dat.data()))
					const data = {
						...d.data(),
						id: d.id
					}
					return data;
				}
			})
			.catch((e) => {
				console.log(e)
			})
	},
	addProducto({ rootState, commit, state }, payload) {
		let opciones;
		let opcionesNombre = [];
		let opcionesNeo = [];
		let opcionesPrecio = [];
		let opcionesTipo = [];
		let modo = rootState.config.modoFuncionamiento;
		let impuestosGlobales = rootState.restaurante.impuestos;

		if (state.seleccionOpciones.length > 0) {
			opciones = JSON.parse(JSON.stringify(state.seleccionOpciones)); //para convertir en un array normal
		} else {
			opciones = [];
		}

		payload.opcionesName.forEach(function (e) {						//Carga las opciones NEO
			opcionesNeo.push(e.mapeoNeo)
		})

		payload.opcionesName.forEach(function (e) {						//Carga los nombres de opciones
			opcionesTipo.push(e.mapeoNeoTipo != undefined ? e.mapeoNeoTipo : null)
			opcionesNombre.push(mostrarIdioma(e.title).trim())
			opcionesPrecio.push(parseFloat(mostrarPrecio(e, modo)))
		})
		var foundImp = impuestosGlobales.find((i) => i.id == state.activeProduct.impuesto);
		var impuestoValor = parseFloat(foundImp.impuesto);
		let carrito = state.carrito.productos;
		let producto = {
			cantidad: payload.cantidad,
			id: state.activeProduct.id,
			mapeoNeo: state.activeProduct.mapeoNeo,
			tipoNeo: state.activeProduct.tipo,
			//impuestoText: mostrarImpuestoTexto(state.activeProduct.impuesto, impuestosGlobales),
			impuesto: impuestoValor,
			nombre: state.activeProduct.nombre,
			opciones: opciones,
			opcionesNeo: opcionesNeo,
			opcionesName: opcionesNombre,
			opcionesPrecio: opcionesPrecio,
			categoria: state.activeProduct.categoria,
			precio: parseFloat(mostrarPrecio(state.activeProduct, modo))
		}

		/*********************************** Busca si ya existe ***********************************/
		let coincide = carrito.findIndex((e) => {
			return e.id === producto.id && (e.opciones).toString() === (producto.opciones).toString();
		})

		if (coincide >= 0) {
			carrito[coincide].cantidad += producto.cantidad
		} else {
			carrito.push(producto)
		}

		commit('addProducto', carrito);
		commit('resetActiveProduct');

	},
	setCantidadProducto({ commit, state }, payload) {
		let carrito = state.carrito.productos;
		carrito[payload.indexArray].cantidad = payload.cant;

		commit('addProducto', carrito);

	},

	finalizarPedido({ state, rootState, commit, dispatch }, tokenStripe) {
		let pedido = {};
		let errores = []

		if (state.activePedido.forma_pago != undefined) {
			pedido.forma_pago = state.activePedido.forma_pago;
		} else {
			errores.push("Error en la forma de pago");
		}

		if (state.activePedido.cambio != undefined) {
			pedido.cambio = state.activePedido.cambio;
		}
		if (state.activePedido.nota && state.activePedido.nota.length > 0) {
			pedido.notaRestaurante = state.activePedido.nota;
		}

		if (state.activePedido.forma_envio != undefined) {
			pedido.modo = state.activePedido.forma_envio;
		}// else{
		// 	return "Error en el modo";
		// }

		if (state.carrito != undefined && state.carrito.productos.length > 0) {
			pedido.carrito = state.carrito;
		} else {
			errores.push("Error en el carrito");
		}


		if (pedido.modo == "domicilio") {
			let comprobacionCalle = state.direccionPedido.calle != "";
			let comprobacionCP = state.direccionPedido.cp != "";
			let comprobacionMunicipio = state.direccionPedido.municipio != "";
			let comprobacionPais = state.direccionPedido.pais != "";
			let comprobacionGPS = state.direccionPedido.coordenadas != "";

			if (comprobacionCalle && comprobacionCP && comprobacionMunicipio && comprobacionPais && comprobacionGPS) {
				pedido.direccion = state.direccionPedido;

			} else {
				errores.push("Error en la direccion");

			}
		}

		if (state.negocioPedido != undefined && state.negocioPedido != null) {
			pedido.negocio = state.negocioPedido;
		} else {
			errores.push("Error en el negocio");
		}

		if (state.restaurantePedido != undefined && state.restaurantePedido != null) {
			pedido.restaurante = state.restaurantePedido
		} else {
			errores.push("Error en el restaurante");
		}

		if (errores.length == 0) {
			if (tokenStripe) {
				pedido.stripeToken = tokenStripe;
				pedido.guardarTarjeta = state.guardarTarjeta;
			}
			pedido.canalVenta = rootState.app.modoGeneral;
			/** para guardar el estado del restaurante y negocio en el pedido */
			pedido.copyRest = state.restauranteObjPedido;
			pedido.copyNegocio = state.negocioObjPedido;
			let fechaAux = new Date();
			pedido.fechaClienteOffset = fechaAux.getTimezoneOffset();
			console.log(pedido);
			var promesa = functions.httpsCallable('httpPedidosInsertarPwa');
			return promesa(pedido)
				.then((r) => {
					const d = r.data;
					console.log(d);
					if (d.ok) {
						commit("setUltimoPedido", d)
						commit('direcciones/resetDirCache', {}, { root: true })
						rootState.app.router.push('/pedir/resumen-pedido')
						dispatch('resetPedido')
					} else if (d.tipo == 'carrito_cambiado') {
						commit('setCarritoComprobadoServidor', d.carritoComprobado)
					} else if (d.tipo == 'pago_online') { //en stripe
						let tipoOnline = d.msj.tipo;
						let idpedido = d.msj.idpedido;
						console.log(d);
						if (tipoOnline == 'stripe_require_action') {
							commit('setStripeRequireActionUrl', d.msj.source.redirect_to_url.url)
							commit('setStripeRequireAction', true);
							commit('snackbar/setMensajeInfo',
								{ msj: 'Necesario validación' },
								{ root: true }
							);
							dispatch('esperandoCambioPagoStripe', idpedido)
							return d;
						}
					} else {
						commit('snackbar/setMensajeInfo',
							{ msj: 'Error al finalizar el pedido: ' + d.msj },
							{ root: true }
						);
					}

				})
				.catch((e) => {
					if (e.tipo == 'carrito_cambiado') {
						commit('snackbar/setMensajeInfo',
							{ msj: 'Carrito cambiado, acepte el nuevo' },
							{ root: true }
						);
					} else {
						//dispatch('resetPedido')
						commit('snackbar/setMensajeInfo',
							{ msj: 'Error al finalizar el pedido: ' + e },
							{ root: true }
						);
					}

				})
				.finally(() => {

				})
		}
	},
	comprobarPagoTokenStripe({ rootState, commit }, pi) {
		var promesa = functions.httpsCallable('httpPedidosStripeTrasPago');
		return promesa(pi)
	},

	esperandoCambioPagoStripe({ state, commit, dispatch, rootState }, idpedido) {
		var unsubscribe = db.collection('pedidos')
			.doc(idpedido)
			.onSnapshot((snap) => {
				const d = snap.data();
				if (d.estado == 'finalizado' && d.stripeCobrado) {
					commit('setStripeRequireActionUrl', '')
					commit('setStripeRequireAction', false);
					commit("setUltimoPedido", d)
					dispatch('resetPedido')
					unsubscribe();
					rootState.app.router.push('/pedir/resumen-pedido')
				} else if (d.estado == 'status/no-succeeded') {
					commit('setStripeRequireActionUrl', '')
					commit('setStripeRequireAction', false);
					commit('snackbar/setMensajeDanger',
						{ msj: 'Error al finalizar el pedido: ' + "Forma de pago no ejecutada" },
						{ root: true }
					);
				}
			})
	},
	comprobarPedido({ state, rootState }) {
		/*let carrito = {
			"productos": [
				{
					"cantidad": 1,
					"id": "jdX0hHnF4XjzVlKByfrx",
					"mapeoNeo": "00000198",
					"tipoNeo": 0,
					"impuesto": 0,
					"nombre": "Wantón",
					"opciones": [],
					"opcionesNeo": [],
					"opcionesName": [],
					"opcionesPrecio": [],
					"precio": 6.9
				},
				{
					"cantidad": 1,
					"id": "Ax8K6Q4IfWYVG4yMzUhm",
					"mapeoNeo": "00000093",
					"tipoNeo": 1,
					"impuesto": 0,
					"nombre": "Padthai Original",
					"opciones": [
						"-LzBf2fPOVoHmV4h2Kih",
						"-LzBf8QH5H8fK3IW08Sm",
						"-LzBfTEhturozzsPveub",
						"-LzBfUMiGvtKTskcLKd5"
					],
					"opcionesNeo": [
						"00000107",
						"00000189",
						"00000092",
						"00000074"
					],
					"opcionesName": [
						"Salsa Vegana",
						"Verduras",
						"No cacahuetes",
						"Medio Picante"
					],
					"opcionesPrecio": [
						0,
						6.8,
						0,
						0
					],
					"precio": 6.8
				},
				{
					"cantidad": 1,
					"id": "Bbhk0IA4lpSVx9VuYSVM",
					"mapeoNeo": "00000907",
					"tipoNeo": 1,
					"impuesto": 0,
					"nombre": "Padthai Calle",
					"opciones": [
						"-LzBf-xZW2tkbdhntphI",
						"-LzBf8Zvh79ymVyYr2p2",
						"-LzBfUMiGvtKTskcLKd5"
					],
					"opcionesNeo": [
						null,
						"00000190",
						"00000074"
					],
					"opcionesName": [
						"Salsa Normal",
						"Pollo",
						"Medio Picante"
					],
					"opcionesPrecio": [
						0,
						8.1,
						0
					],
					"precio": 6.8
				},
				{
					"cantidad": 1,
					"id": "BS1W4dNsAzZCz0kKPdtt",
					"mapeoNeo": "00000005",
					"tipoNeo": 0,
					"impuesto": 0,
					"nombre": "Coca Cola light",
					"opciones": [],
					"opcionesNeo": [],
					"opcionesName": [],
					"opcionesPrecio": [],
					"precio": 2
				}
			],
			"numero_producto": 4,
			"precio_total": 37.4
		}*/
		var promesa = functions.httpsCallable('httpPedidosComprobar');
		let datos = {
			carrito: state.carrito,
			negocio: rootState.restaurante.activeNegocio,
			restaurante: state.restaurantePedido
		}
		return promesa(datos)
			.then((r) => {
				return r.data;
			})
			.catch((e) => {
				return e;
			})
	},
	movimientoPorFinalizar({ commit, state, rootState }, payload) {
		let paso = state.pasoFinalizar;
		let isLogged = rootState.auth.isLogged;
		let newStep = 1;

		switch (payload) { //"next" | "back"
			case "next":
				newStep = isLogged && paso == 1 || paso == 2 ? 3 : 2;
				break;
			default:
				newStep = paso == 2 || isLogged ? 1 : 2;
				break;
		}

		commit("setPasoFinalizar", newStep)
	},
	localStorageLoad({ state, rootState, commit, dispatch }) {
		if (localStorage.getItem('shoppingCart') != null) {
			let temp1 = JSON.parse(localStorage.getItem('shoppingCart'));
			commit("setPedidoPendienteCarrito", temp1);
		}

		if (localStorage.getItem('activePedido') != null) {
			let temp2 = JSON.parse(localStorage.getItem('activePedido'));
			commit("setPedidoPendientePedido", temp2);
		}
		if (localStorage.getItem('pedidoMinimo') != null) {
			let minimo = JSON.parse(localStorage.getItem('pedidoMinimo'));
			commit("setPedidoMinimo", minimo);
		}
		if (localStorage.getItem('recargo') != null) {
			let recargo = JSON.parse(localStorage.getItem('recargo'));
			commit("setRecargoPedido", recargo);
		}

		if (localStorage.getItem('dirPidiendo') != null) {
			let temp3 = JSON.parse(localStorage.getItem('dirPidiendo'));
			commit("setPedidoPendienteDireccion", temp3);
		}
		if (localStorage.getItem('negocioPedido') != null) {
			let temp4 = localStorage.getItem('negocioPedido');
			commit("setPedidoPendienteNegocio", temp4);
		}

		if (localStorage.getItem('activeRestId') != null) {
			let _vue = this;
			let rest = localStorage.getItem('activeRestId');
			//traer negocio en funeat
			let negocio = rootState.propio.negocioPropio ? rootState.propio.negocioPropio : ''
			//rest = negocio + '-' + rest;
			commit("setPedidoPendienteRestaurante", rest);
			dispatch('restaurante/getRestNegocioParametros', {
				negocio: negocio,
				rest: rest
			}, { root: true }).then((r) => {
				if (r[1]) {
					commit("setRestauranteObjPedido", r[1]);
					commit("setPedidoPendienteRestauranteObj", r[1]);
				}
				if (r[0]) {
					commit("setPedidoPendienteNegocioObj", r[0]);
					commit("setNegocioObjPedido", r[0]);
				}
			})
		}
	},
	generarFactura({ state }, payload) {
		var promesa = functions.httpsCallable('httpUsersGenerarFactura');
		return promesa({
			idPedido: payload.idPedido
		})
	}
}







